import { RangeFromTo } from '../../../../../../../types/charts';
import { MeasurementRange } from '../../../../../../../types/measurement';
import { convertDateToString } from '../../../../../../../utils/helpers/date-convert';
import { ChartDataItem } from '../types';
import { currentFormat } from './helpers';

const createChartDataItem = (date: Date, activeMeasurementRange: MeasurementRange): ChartDataItem => ({
  date: date.getTime(),
  time: convertDateToString(date.getTime(), currentFormat(false, activeMeasurementRange)),
  tooltipTime: convertDateToString(date.getTime(), currentFormat(true, activeMeasurementRange)),
  values: [],
});

const getDateIncrementFunction = (activeMeasurementRange: MeasurementRange) => {
  switch (activeMeasurementRange) {
    case MeasurementRange.DayInHours:
      return (date: Date) => date.setHours(date.getHours() + 1);
    case MeasurementRange.WeekInDays:
    case MeasurementRange.MonthInDays:
      return (date: Date) => date.setDate(date.getDate() + 1);
    case MeasurementRange.YearInMonths:
      return (date: Date) => date.setMonth(date.getMonth() + 1);
    case MeasurementRange.TenYearsInYears:
      return (date: Date) => date.setFullYear(date.getFullYear() + 1);
    default:
      return (date: Date) => date.setDate(date.getDate() + 1);
  }
};

export const generateEmptyData = (
  activeMeasurementRange: MeasurementRange,
  { from, to }: RangeFromTo,
): ChartDataItem[] => {
  const arr: ChartDataItem[] = [];
  let currentDate = new Date(from);
  const endDate = new Date(to);
  const incrementDate = getDateIncrementFunction(activeMeasurementRange);

  while (currentDate <= endDate) {
    arr.push(createChartDataItem(new Date(currentDate), activeMeasurementRange));
    incrementDate(currentDate);
  }

  return arr;
};
